const chainCurrencies = [
  { symbol: 'BTC', name: 'Bitcoin' },
  { symbol: 'ETH', name: 'Ether' }
];

const fiat = [
  { symbol: 'CHF', name: 'Swiss Franc' },
  { symbol: 'USD', name: 'US Dollar' },
  { symbol: 'EUR', name: 'Euro' }
];

export { chainCurrencies, fiat };
